import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import styles from "./Pdf.module.scss";

// The worker is served from /public rather than bundled via webpack (e.g. new URL(..., import.meta.url))
// because CRA's webpack wraps the file in its module runtime, which uses `require` —
// but `require` is not available inside a Web Worker context, causing a runtime error.
// The file is copied from node_modules by the `postinstall` script in package.json.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/static/pdf.worker.min.js`;

export default function Pdf({ pdfFile, numPages, onDocumentLoadSuccess, onDocumentLoadError }) {
  return (
    <>
      <div className={styles.pdf}>
        <Document
          file={pdfFile}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          loading={
            <div className={styles.loading}>
              <div className="spinner-border text-light" role="status">
                <span className="sr-only">Loading PDF...</span>
              </div>
              <div className={styles.loadingText}>Loading PDF...</div>
            </div>
          }
        >
          {Array.from(new Array(numPages), (el, index) => (
            <div key={`page_${index + 1}`} className={styles.pages}>
              <Page pageNumber={index + 1} scale={1.33} renderTextLayer renderAnnotationLayer />
            </div>
          ))}
        </Document>
      </div>

      {numPages && <div className={styles.numPages}>Total Pages: {numPages}</div>}
    </>
  );
}
